import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const HandbookPreview = ({ handbook, editMode = false }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Suppress font loading errors from Google Docs
  useEffect(() => {
    const originalError = console.error;
    console.error = (...args) => {
      if (
        typeof args[0] === 'string' &&
        (args[0].includes('filesystem:https://docs.google.com/persistent/docs/fonts/') ||
         args[0].includes('ERR_FILE_NOT_FOUND'))
      ) {
        return;
      }
      originalError.apply(console, args);
    };

    return () => {
      console.error = originalError;
    };
  }, []);

  // Handle find in document
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === 'triggerFind') {
        // Trigger the browser's find functionality in the iframe
        const iframe = document.querySelector('iframe');
        if (iframe) {
          iframe.contentWindow.focus();
          // Simulate Ctrl+F to open the browser's find dialog
          const event = new KeyboardEvent('keydown', {
            key: 'f',
            code: 'KeyF',
            ctrlKey: true,
            bubbles: true
          });
          iframe.contentWindow.dispatchEvent(event);
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  if (!handbook) {
    return null;
  }

  return (
    <Box sx={{ 
      height: '100%',
      width: '100%',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {loading && (
        <Box sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.paper',
          zIndex: 1
        }}>
          <CircularProgress />
        </Box>
      )}
      <iframe
        src={`https://docs.google.com/document/d/${handbook.id}/${editMode ? 'edit' : 'preview'}`}
        title={handbook.name}
        width="100%"
        height="100%"
        frameBorder="0"
        style={{
          border: 'none',
          background: '#fff'
        }}
        onLoad={() => setLoading(false)}
        onError={(e) => {
          setError('Failed to load document');
          setLoading(false);
        }}
      />
      {error && (
        <Box sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.paper',
          zIndex: 1
        }}>
          <Typography color="error">{error}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default HandbookPreview; 